import type { CharacterControllerConfig } from './CharacterController';
import type { ViewerConfig } from '../transformers/sceneToConfig';
import { playerCollisionRadius } from '../utils/playerSize';

export type WalkControllerSceneSettings = Pick<
    ViewerConfig,
    'walkSpeed' | 'cameraRotationSensitivity' | 'invertCameraRotation' | 'playerHeight' | 'playerWidth'
>;

/**
 * Walk-mode CharacterController settings from the scene config. Shared by both creation sites in
 * createViewer — eager (the scene ships collision) and lazy (collision arrives later, e.g. from the
 * editor or a swap's own set) — so the creator's walk settings can't drift between them.
 */
export function buildWalkControllerConfig(
    config: WalkControllerSceneSettings,
    baseMoveSpeed: number,
): CharacterControllerConfig {
    return {
        moveSpeed: config.walkSpeed != null ? config.walkSpeed : baseMoveSpeed,
        sprintMultiplier: 2,
        lookSensitivity: (1 / (config.cameraRotationSensitivity || 4000)) * 10,
        invertCameraRotation: config.invertCameraRotation,
        playerHeight: config.playerHeight || 1.6,
        gravity: 20,
        jumpVelocity: 8,
        // Creator "Player Width" (diameter) → horizontal collision radius; absent = 0.3 as before.
        collisionRadius: playerCollisionRadius(config.playerWidth),
        stepHeight: 0.3,
    };
}
